module.exports = __webpack_public_path__ + "img/upload_image.9d931284.png";